import { render, staticRenderFns } from "./LanguageObjectInputPopup.vue?vue&type=template&id=344055ec"
import script from "./LanguageObjectInputPopup.vue?vue&type=script&lang=js"
export * from "./LanguageObjectInputPopup.vue?vue&type=script&lang=js"
import style0 from "./LanguageObjectInputPopup.vue?vue&type=style&index=0&id=344055ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports